import { DATE_MAX_STR, DATE_MIN_STR } from "../constants/constants";
import { IDateRange } from "../interfaces/IDateRange";
import { SearchDateRange } from "../interfaces/SearchDateRange";

export function getEndOfDay(date: Date) {
    return new Date(date.setHours(23, 59, 59, 999));
}

export function getLast90DaysDateRange(): IDateRange {
    var endDate = new Date(); // Current date and time
    var startDate = new Date();
  
    startDate.setDate(endDate.getDate() - 90);
  
    startDate.setHours(0, 0, 0, 0);
  
    return {startDate: startDate, endDate: endDate };
}


export function getTodayDateRange(): IDateRange {
    var endDate = new Date(); // Current date and time
    var startDate = new Date();
  
    startDate.setHours(0, 0, 0, 0);
  
    return { startDate: startDate, endDate: endDate };
}

export function getThisWeekDateRange() {
    var currentDate = new Date();
    var today = currentDate.getDay();
  
    var startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - today);
  
    var endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
  
    return { startDate: startDate, endDate: endDate };
  }

  export function getLastWeekDateRange() {
    var currentDate = new Date();
    var today = currentDate.getDay();
  
    var startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - today - 7);
  
    var endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
  
    return { startDate: startDate, endDate: endDate };
  }

  export function getThisMonthDateRange() {
    var currentDate = new Date();
    var firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  
    firstDayOfMonth.setHours(0, 0, 0, 0);
    lastDayOfMonth.setHours(23, 59, 59, 999);
  
    return { startDate: firstDayOfMonth, endDate: lastDayOfMonth };
  }

  export function getLastMonthDateRange() {
    var currentDate = new Date();
    var firstDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
  
    return { startDate: firstDayOfLastMonth, endDate: lastDayOfLastMonth };
  }
  
export function getThisQuarterDateRange() {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth();
    var quarterStartMonth = Math.floor(currentMonth / 3) * 3; 

    var firstDayOfThisQuarter = new Date(currentDate.getFullYear(), quarterStartMonth, 1);
    var lastDayOfThisQuarter = new Date(currentDate.getFullYear(), quarterStartMonth + 2, 0);

    firstDayOfThisQuarter.setHours(0, 0, 0, 0);
    lastDayOfThisQuarter.setHours(23, 59, 59, 999);

    return { startDate: firstDayOfThisQuarter, endDate: lastDayOfThisQuarter };
  }

  export function getLastQuarterDateRange() {
    var currentDate = new Date();
    var quarterStartMonth = Math.floor(currentDate.getMonth() / 3) * 3;

    var firstDayOfLastQuarter = new Date(currentDate.getFullYear(), quarterStartMonth - 3, 1);
    var lastDayOfLastQuarter = new Date(currentDate.getFullYear(), quarterStartMonth - 1, 0);

    firstDayOfLastQuarter.setHours(0, 0, 0, 0);
    lastDayOfLastQuarter.setHours(23, 59, 59, 999);

    return { startDate: firstDayOfLastQuarter, endDate: lastDayOfLastQuarter };
  }

  export function getThisYearDateRange() {
    var currentDate = new Date();
    var firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1);
    var lastDayOfYear = new Date(currentDate.getFullYear(), 11, 31);

    firstDayOfYear.setHours(0, 0, 0, 0);
    lastDayOfYear.setHours(23, 59, 59, 999);
  
    return { startDate: firstDayOfYear, endDate: lastDayOfYear };
  }

  export function getLastYearDateRange() {
    var currentDate = new Date();
    var firstDayOfLastYear = new Date(currentDate.getFullYear() - 1, 0, 1);
    var lastDayOfLastYear = new Date(currentDate.getFullYear() - 1, 11, 31);
  
    firstDayOfLastYear.setHours(0, 0, 0, 0);
    lastDayOfLastYear.setHours(23, 59, 59, 999);
  
    return { startDate: firstDayOfLastYear, endDate: lastDayOfLastYear };
  }

  export function getDateRange(period: SearchDateRange): IDateRange {
    switch (period) {
      case SearchDateRange.Last90Days:
        return getLast90DaysDateRange();

      case SearchDateRange.Today:
        return getTodayDateRange();

      case SearchDateRange.ThisWeek:
        return getThisWeekDateRange();

      case SearchDateRange.LastWeek:
        return getLastWeekDateRange();

      case SearchDateRange.ThisMonth:
        return getThisMonthDateRange();

      case SearchDateRange.LastMonth:
        return getLastMonthDateRange();

      case SearchDateRange.ThisQuarter:
        return getThisQuarterDateRange();

      case SearchDateRange.LastQuarter:
        return getLastQuarterDateRange();

      case SearchDateRange.ThisYear:
        return getThisYearDateRange();

      case SearchDateRange.LastYear:
        return getLastYearDateRange();

      default:
        return {
          startDate: new Date(DATE_MIN_STR),
          endDate: new Date(DATE_MAX_STR),
        };
    }
  }
  
  
  